import React from "react";
import styles from "./DescTwo.module.scss";

function DescTwo({ value }) {
  return <div className={styles.descTwo}>{value}</div>;
}

export default DescTwo;
